import { render, staticRenderFns } from "./RequestHistoryActionAppeal.vue?vue&type=template&id=13a3dfa8&"
import script from "./RequestHistoryActionAppeal.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryActionAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequestHistoryActionAppeal.vue"
export default component.exports